import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GuildDashboard from './GuildDashboard';
import GuildCreation from './GuildCreation';
import GuildProfile from './GuildProfile';
import GuildLeague from '../Pages/GuildLeague';

const GuildRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<GuildDashboard />} />
      <Route path="/create" element={<GuildCreation />} />
      <Route path="/league" element={<GuildLeague />} />
      <Route path="/:id" element={<GuildProfile />} />
    </Routes>
  );
};

export default GuildRoutes;
